import { Checkbox, ThemeProvider } from "@mui/material";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import AnimateHeight from "react-animate-height";
import SpecialistApi from "../../../../../../api/specialistsApi";
import { ReactComponent as ListCheck } from "../../../../../../assets/Companies/list-check.svg";
import { ReactComponent as ListCross } from "../../../../../../assets/Companies/list-cross.svg";
import { ReactComponent as ChevronDown } from "../../../../../../assets/General/chevronDown.svg";
import CustomTooltip from "../../../../../../components/CustomTooltip/CustomTooltip";
import Input from "../../../../../../components/Input/Input";
import ModalWindow from "../../../../../../components/ModalWindow/ModalWindow";
import StandartButton from "../../../../../../components/StandartButton/StandartButton";
import { directions } from "../../../../../../constans/directions";
import { siteLangs } from "../../../../../../constans/siteLangs";
import { TypeNewTag } from "../../../../../../types/Projects";
import { SpecialistTag } from "../../../../../../types/TypeSpecialist";
import { theme } from "../../../../../../utils/theme";
import s from "./ProjectTags.module.css";

type DropDownMenuData = {
  lable: string;
  value: string;
  parentTag?: string;
  labels: { language: string; text: string }[];
  isNew?: boolean;
};
type TagsData = {
  level1: DropDownMenuData[];
  level2: DropDownMenuData[];
  level3: DropDownMenuData[];
};

type ProjectTagsProps = {
  mainSpecialization: string;
  setProjectTags: Dispatch<
    SetStateAction<{ [specialization: string]: TypeNewTag[] }>
  >;
  oldProjectTags?: SpecialistTag[];
};

const ProjectTags = ({
  mainSpecialization,
  setProjectTags,
  oldProjectTags,
}: ProjectTagsProps) => {
  const token = localStorage.getItem("token");
  const [tags, setTags] = useState<TagsData>({
    level1: [],
    level2: [],
    level3: [],
  });
  const [selectedTags, setSelectedTags] = useState<{
    level1: { _id: string; parentTag?: string }[];
    level2: { _id: string; parentTag: string }[];
    level3: { _id: string; parentTag: string }[];
  }>({
    level1: oldProjectTags
      ? oldProjectTags
          .filter((el) => el.level === 1)
          .map((item) => {
            return { _id: item._id };
          })
      : [],
    level2: oldProjectTags
      ? oldProjectTags
          .filter((el) => el.level === 2)
          .map((item) => {
            return { _id: item._id, parentTag: item.parentTag! };
          })
      : [],
    level3: oldProjectTags
      ? oldProjectTags
          .filter((el) => el.level === 3)
          .map((item) => {
            return { _id: item._id, parentTag: item.parentTag! };
          })
      : [],
  });
  const [collapsedDirections, setCollapsedDirections] = useState<{
    level1: string[];
    level2: string[];
  }>({ level1: [], level2: [] });
  const [newTagModal, setNewTagModal] = useState(false);
  const [selecLangForText, setSelecLangForText] = useState("en");
  const [newTagText, setNewTagText] = useState<
    { language: string; text: string }[]
  >(siteLangs.map((item) => ({ language: item.value, text: "" })));
  const [newTagLevel, setNewTagLevel] = useState<1 | 2 | 3 | null>(null); // Уровень нового тега
  const [parentTagId, setParentTagId] = useState<string | null>(null);

  const checkCurrentlyTreeTag = (
    parentTagId: string,
    subTagsArr: { _id: string; parentTag: string }[],
  ) => {
    const subTagsParentIds = subTagsArr.map((item) => item.parentTag);
    return subTagsParentIds.includes(parentTagId);
  };
  const gatTags = async (
    level: number,
    keyForChange: keyof TagsData,
    parentTagsIds?: string[],
  ) => {
    if (!token) return;
    const payload = {
      level: level,
      direction: directions[mainSpecialization],
      parentTagsIds: parentTagsIds,
    };
    const response = await SpecialistApi.getSpecialistTags(token, payload);

    if (response.status && response.tags) {
      const tagsData = response.tags.map((item) => ({
        lable: item.labels.find((el) => el.language === "en")!.text,
        value: item._id,
        parentTag: item.parentTag,
      }));
      const oldTagsData = oldProjectTags
        ? oldProjectTags
            .filter((tag) => tag.level === level)
            .map((item) => ({
              lable: item.labels.find((el) => el.language === "en")!.text,
              value: item._id,
              parentTag: item.parentTag,
            }))
        : [];

      const merged = [...tagsData, ...oldTagsData];
      const unique = Array.from(
        new Map(merged.map((tag) => [tag.value, tag])).values(),
      );

      setTags((prev) => ({ ...prev, [keyForChange]: unique }));
    }
  };
  useEffect(() => {
    gatTags(1, "level1");
  }, [mainSpecialization]);
  useEffect(() => {
    setSelectedTags((prev) => ({
      ...prev,
      level2: prev.level2.filter((el) =>
        prev.level1.map((item) => item._id).includes(el.parentTag),
      ),
    }));
    gatTags(
      2,
      "level2",
      selectedTags.level1.map((item) => item._id),
    );
  }, [selectedTags.level1]);

  useEffect(() => {
    setSelectedTags((prev) => ({
      ...prev,
      level3: prev.level3.filter((el) =>
        prev.level2.map((item) => item._id).includes(el.parentTag),
      ),
    }));
    gatTags(
      3,
      "level3",
      selectedTags.level2.map((item) => item._id),
    );
  }, [selectedTags.level2]);

  const checkIfSelectedTag = (
    tagId: string,
    selectedTags: { _id: string; parentTag?: string }[],
  ) => {
    const arrAllTagsIds = selectedTags.map((item) => item._id);
    return arrAllTagsIds.includes(tagId);
  };

  const checkAll3levelChildTags = (parentTagId: string) => {
    const childTags = tags.level3
      .filter((tag) => tag.parentTag === parentTagId)
      .map((item) => ({
        _id: item.value,
        parentTag: item.parentTag ?? "",
      }));
    const mergedTags = [...childTags, ...selectedTags.level3];
    const uniqueTags = Array.from(
      new Map(mergedTags.map((item) => [item._id, item])).values(),
    );
    setSelectedTags((prev) => ({ ...prev, level3: uniqueTags }));
  };
  const uncheckAll3levelChildTags = (parentTagId: string) => {
    const filteredTags = selectedTags.level3.filter(
      (tag) => tag.parentTag !== parentTagId,
    );
    setSelectedTags((prev) => ({ ...prev, level3: filteredTags }));
  };

  const validateNewTag = () => {
    const isValid = newTagText.every((item) => item.text.trim() !== "");
    if (!isValid) {
      alert("Please fill in the tag text for all languages.");
      return false;
    }
    return true;
  };
  const generateTempId = () => crypto.randomUUID();
  const addNewTag = () => {
    if (!newTagLevel || !validateNewTag()) return;

    const newTagId = generateTempId();
    const newTagData: DropDownMenuData = {
      lable: newTagText.find((el) => el.language === "en")!.text,
      value: newTagId,
      parentTag: parentTagId || undefined,
      labels: newTagText,
      isNew: true,
    };

    setTags((prev) => ({
      ...prev,
      [`level${newTagLevel}`]: [...prev[`level${newTagLevel}`], newTagData],
    }));

    setSelectedTags((prev) => ({
      ...prev,
      [`level${newTagLevel}`]: [
        ...prev[`level${newTagLevel}`],
        { _id: newTagId, parentTag: parentTagId || "" },
      ],
    }));

    setNewTagModal(false);
    setNewTagText(
      siteLangs.map((item) => ({ language: item.value, text: "" })),
    );
    setNewTagLevel(null);
    setParentTagId(null);
    setSelecLangForText("en");
  };

  const transformToTypeNewTag = (): TypeNewTag[] => {
    return selectedTags.level1.map((level1Tag) => {
      const level1TagData = tags.level1.find(
        (tag) => tag.value === level1Tag._id,
      );

      const level2Tags = selectedTags.level2
        .filter((level2Tag) => level2Tag.parentTag === level1Tag._id)
        .map((level2Tag) => {
          const level2TagData = tags.level2.find(
            (tag) => tag.value === level2Tag._id,
          );

          const level3Tags = selectedTags.level3
            .filter((level3Tag) => level3Tag.parentTag === level2Tag._id)
            .map((level3Tag) => {
              const level3TagData = tags.level3.find(
                (tag) => tag.value === level3Tag._id,
              );
              return {
                _id: level3TagData?.isNew ? undefined : level3Tag._id,
                title: level3TagData?.lable || "",
                labels: level3TagData?.labels || [],
                direction: directions[mainSpecialization],
              };
            });

          return {
            _id: level2TagData?.isNew ? undefined : level2Tag._id,
            title: level2TagData?.lable || "",
            labels: level2TagData?.labels || [],
            direction: directions[mainSpecialization],
            tags: level3Tags,
          };
        });

      return {
        _id: level1TagData?.isNew ? undefined : level1Tag._id,
        title: level1TagData?.lable || "",
        labels: level1TagData?.labels || [],
        direction: directions[mainSpecialization],
        tags: level2Tags,
      };
    });
  };

  useEffect(() => {
    setProjectTags((prev) => ({
      ...prev,
      [mainSpecialization]: transformToTypeNewTag(),
    }));
  }, [selectedTags]);

  return (
    <div className={s.container}>
      <div className={s.actionBlock}>
        <h2>{directions[mainSpecialization]} Tags</h2>
        <div className={s.headBlockInfo}>
          <div className={s.summaryBlock}>
            <div
              className={s.summaryElement}
              style={{ borderRight: "1px solid rgba(0, 0, 0, 0.2)" }}
            >
              <span>{"Selected directions - "}</span>
              <span className={s.summaryValue}>
                {selectedTags.level1.length}
              </span>
            </div>
            <div
              className={s.summaryElement}
              style={{ borderRight: "1px solid rgba(0, 0, 0, 0.2)" }}
            >
              <span>{"Selected topics - "}</span>
              <span className={s.summaryValue}>
                {selectedTags.level2.length}
              </span>
            </div>
            <div className={s.summaryElement}>
              <span>{"Selected results - "}</span>
              <span className={s.summaryValue}>
                {selectedTags.level3.length}
              </span>
            </div>
          </div>
          <div
            className={s.collapseAllBtn}
            onClick={() =>
              setCollapsedDirections({
                level1: selectedTags.level1.map((item) => item._id),
                level2: selectedTags.level2.map((item) => item._id),
              })
            }
          >
            Collapse all
          </div>
        </div>
        <div style={{ borderLeft: "1px solid gray" }}>
          {tags.level1.map((item1) => (
            <div className={s.tagElementBlock} key={item1.value}>
              <ThemeProvider theme={theme}>
                <div className={s.tagElementValueBlock}>
                  <Checkbox
                    checked={checkIfSelectedTag(
                      item1.value,
                      selectedTags.level1,
                    )}
                    inputProps={{ "aria-label": "controlled" }}
                    color={"primary"}
                    onClick={() =>
                      setSelectedTags((prev) => ({
                        ...prev,
                        level1: checkIfSelectedTag(
                          item1.value,
                          selectedTags.level1,
                        )
                          ? prev.level1.filter((el) => el._id !== item1.value)
                          : [...prev.level1, { _id: item1.value }],
                      }))
                    }
                    sx={{ color: "white" }}
                  />
                  {!checkIfSelectedTag(item1.value, selectedTags.level1) ||
                  checkCurrentlyTreeTag(item1.value, selectedTags.level2) ? (
                    <span>{item1.lable}</span>
                  ) : (
                    <CustomTooltip
                      title={"Choose at least one item from the list below"}
                    >
                      <span className={s.notCorrectSelectedTags}>
                        {item1.lable}
                      </span>
                    </CustomTooltip>
                  )}
                  {checkIfSelectedTag(item1.value, selectedTags.level1) && (
                    <ChevronDown
                      onClick={() =>
                        setCollapsedDirections((prev) => ({
                          ...prev,
                          level1: prev.level1.includes(item1.value)
                            ? prev.level1.filter((el) => el !== item1.value)
                            : [...prev.level1, item1.value],
                        }))
                      }
                      className={
                        collapsedDirections.level1.includes(item1.value)
                          ? s.chevronDown
                          : s.chevronUp
                      }
                    />
                  )}
                </div>
              </ThemeProvider>

              <AnimateHeight
                height={
                  collapsedDirections.level1.includes(item1.value) ? 0 : "auto"
                }
              >
                <div
                  style={{ marginLeft: "30px", borderLeft: "1px solid gray" }}
                >
                  {tags.level2
                    .filter((el) => el.parentTag === item1.value)
                    .map((item2, index2) => (
                      <div className={s.tagElementBlock} key={item2.value}>
                        <div className={s.tagElementValueBlock}>
                          <ThemeProvider theme={theme}>
                            <Checkbox
                              checked={checkIfSelectedTag(
                                item2.value,
                                selectedTags.level2,
                              )}
                              inputProps={{ "aria-label": "controlled" }}
                              color={"primary"}
                              onClick={() =>
                                setSelectedTags((prev) => ({
                                  ...prev,
                                  level2: checkIfSelectedTag(
                                    item2.value,
                                    selectedTags.level2,
                                  )
                                    ? prev.level2.filter(
                                        (el) => el._id !== item2.value,
                                      )
                                    : [
                                        ...prev.level2,
                                        {
                                          _id: item2.value,
                                          parentTag: item2.parentTag!,
                                        },
                                      ],
                                }))
                              }
                              sx={{ color: "white" }}
                            />
                          </ThemeProvider>
                          {!checkIfSelectedTag(
                            item2.value,
                            selectedTags.level2,
                          ) ||
                          checkCurrentlyTreeTag(
                            item2.value,
                            selectedTags.level3,
                          ) ? (
                            <span>{item2.lable}</span>
                          ) : (
                            <CustomTooltip
                              title={
                                "Choose at least one item from the list below"
                              }
                            >
                              <span className={s.notCorrectSelectedTags}>
                                {item2.lable}
                              </span>
                            </CustomTooltip>
                          )}
                          {checkIfSelectedTag(
                            item2.value,
                            selectedTags.level2,
                          ) && (
                            <div className={s.iconsActionBlock}>
                              <ChevronDown
                                onClick={() =>
                                  setCollapsedDirections((prev) => ({
                                    ...prev,
                                    level2: prev.level2.includes(item2.value)
                                      ? prev.level2.filter(
                                          (el) => el !== item2.value,
                                        )
                                      : [...prev.level2, item2.value],
                                  }))
                                }
                                className={
                                  collapsedDirections.level2.includes(
                                    item2.value,
                                  )
                                    ? s.chevronDown
                                    : s.chevronUp
                                }
                              />
                              <div
                                role={"button"}
                                className={s.checkButton}
                                onClick={() =>
                                  checkAll3levelChildTags(item2.value)
                                }
                              >
                                <ListCheck width={22} height={22} />
                              </div>
                              <div
                                role={"button"}
                                className={s.unCheckButton}
                                onClick={() =>
                                  uncheckAll3levelChildTags(item2.value)
                                }
                              >
                                <ListCross width={22} height={22} />
                              </div>
                            </div>
                          )}
                        </div>
                        <AnimateHeight
                          height={
                            collapsedDirections.level2.includes(item2.value)
                              ? 0
                              : "auto"
                          }
                        >
                          <div
                            style={{
                              marginLeft: "30px",
                              borderLeft: "1px solid gray",
                            }}
                          >
                            {tags.level3
                              .filter((el) => el.parentTag === item2.value)
                              .map((item3, index3) => (
                                <div
                                  className={s.tagElementBlock}
                                  key={item3.value}
                                >
                                  <div className={s.tagElementValueBlock}>
                                    <ThemeProvider theme={theme}>
                                      <Checkbox
                                        checked={checkIfSelectedTag(
                                          item3.value,
                                          selectedTags.level3,
                                        )}
                                        inputProps={{
                                          "aria-label": "controlled",
                                        }}
                                        color={"primary"}
                                        onClick={() =>
                                          setSelectedTags((prev) => ({
                                            ...prev,
                                            level3: checkIfSelectedTag(
                                              item3.value,
                                              selectedTags.level3,
                                            )
                                              ? prev.level3.filter(
                                                  (el) =>
                                                    el._id !== item3.value,
                                                )
                                              : [
                                                  ...prev.level3,
                                                  {
                                                    _id: item3.value,
                                                    parentTag: item3.parentTag!,
                                                  },
                                                ],
                                          }))
                                        }
                                        sx={{ color: "white" }}
                                      />
                                    </ThemeProvider>
                                    <span>{item3.lable}</span>
                                  </div>
                                </div>
                              ))}
                            {checkIfSelectedTag(
                              item2.value,
                              selectedTags.level2,
                            ) && (
                              <div
                                className={s.addTagBtn}
                                role="button"
                                onClick={() => {
                                  setNewTagLevel(3);
                                  setParentTagId(item2.value);
                                  setNewTagModal(true);
                                }}
                              >
                                + Add new result
                              </div>
                            )}
                          </div>
                        </AnimateHeight>
                      </div>
                    ))}
                  {checkIfSelectedTag(item1.value, selectedTags.level1) && (
                    <div
                      className={s.addTagBtn}
                      role="button"
                      onClick={() => {
                        setNewTagLevel(2);
                        setParentTagId(item1.value);
                        setNewTagModal(true);
                      }}
                    >
                      + Add new topic
                    </div>
                  )}
                </div>
              </AnimateHeight>
            </div>
          ))}
        </div>
        <div
          className={s.addTagBtn}
          role="button"
          onClick={() => {
            setNewTagLevel(1);
            setParentTagId(null);
            setNewTagModal(true);
          }}
        >
          + Add new direction
        </div>
      </div>
      <ModalWindow
        isOpen={newTagModal}
        setIsOpen={setNewTagModal}
        width="400px"
      >
        <div className={s.newTagModal}>
          <div className={s.langsBlock}>
            {siteLangs.map((item, index) => (
              <div
                key={index}
                className={
                  selecLangForText === item.value ? s.activeTab : s.notActiveTab
                }
                onClick={() => setSelecLangForText(item.value)}
              >
                {item.lable}
                {selecLangForText === item.value && (
                  <span className={s.tabIndicator}></span>
                )}
              </div>
            ))}
          </div>
          <Input
            inputValue={
              newTagText.find((el) => el.language === selecLangForText)?.text ??
              ""
            }
            onChangeInput={(value) => {
              setNewTagText((prev) =>
                prev.map((item) =>
                  item.language === selecLangForText
                    ? { language: item.language, text: value }
                    : item,
                ),
              );
            }}
          />
          <StandartButton buttonTitle="Add" action={addNewTag} width="200px" />
        </div>
      </ModalWindow>
    </div>
  );
};

export default ProjectTags;
